document.addEventListener('DOMContentLoaded', function () {
    console.log('DOM cargado inicialmente');
    
    // Ejecutar cálculo inicial
    calcularDiasEntrega();
    
    // Escuchar cambios de variante usando MutationObserver
    const targetNode = document.querySelector('.product-form');
    if (targetNode) {
        const observer = new MutationObserver(function(mutations) {
            console.log('Variante cambiada detectada');
            // Dar tiempo a que Shopify actualice los metadatos de la variante
            setTimeout(function() {
                console.log('Reconsultando metadatos después del cambio de variante');
                calcularDiasEntrega();
            }, 200);
        });
        
        observer.observe(targetNode, { 
            attributes: true, 
            childList: true, 
            subtree: true 
        });
    }
    
    // También escuchar el evento de cambio de variante de Shopify
    document.addEventListener('variant:change', function(event) {
        console.log('Evento variant:change detectado');
        console.log('Datos del evento:', event.detail);
        
        // Dar tiempo a que Shopify actualice metaDataVariant
        setTimeout(function() {
            console.log('Reconsultando metadatos después del evento variant:change');
            calcularDiasEntrega();
        }, 200);
    });
});

    // Función principal para calcular días de entrega
    function calcularDiasEntrega() {
        console.log('Calculando días de entrega');
        
        // Verificar que los metadatos y elementos del DOM existan
        if (!window.metaDataVariant || !document.getElementById('toDate2') || !document.getElementById('fromDate2')) {
            console.log('Esperando elementos necesarios...');
            setTimeout(calcularDiasEntrega, 100);
            return;
        }
        
    // Asegurarse de obtener los metadatos actualizados de la variante seleccionada actual
    console.log('Metadata de variante:', window.metaDataVariant);
    
    // Obtener la variante seleccionada actualmente
    const variantInput = document.querySelector('input[name="id"]');
    const currentVariantId = variantInput ? variantInput.value : null;
    
    // Si tenemos ID de variante y está en nuestros metadatos, actualizar los días de entrega
    if (currentVariantId && window.metaDataVariant.variantMetafields && 
        window.metaDataVariant.variantMetafields[currentVariantId]) {
        
        // Actualizar los días de entrega desde los metadatos de la variante actual
        window.metaDataVariant.deliverysDays = 
            window.metaDataVariant.variantMetafields[currentVariantId].dias;
        
        console.log('Días de entrega actualizados desde variantMetafields:', 
                    window.metaDataVariant.deliverysDays);
    }
    
    // Obtener días de entrega del metadato (ahora actualizado)
    let diasDeEntrega = window.metaDataVariant.deliverysDays;
    console.log('Días de entrega a utilizar:', diasDeEntrega);
    
    // Calcular fechas reales de entrega (considerando fines de semana)
    let fechaActual = Date.today();
    let fechaEntrega = Date.today();
    let diasHabiles = 0;
    let diasTotales = 0;
    
    // Calcular la primera fecha de entrega
    while (diasHabiles < diasDeEntrega) {
        diasTotales++;
        fechaEntrega = Date.today().addDays(diasTotales);
        
        // Solo contar días de semana (no sábados ni domingos)
        if (!fechaEntrega.is().saturday() && !fechaEntrega.is().sunday()) {
            diasHabiles++;
        }
    }
    
    // Calcular la segunda fecha de entrega (día siguiente hábil)
    let fechaEntregaMax = fechaEntrega.clone().addDays(1);
    // Si cae en fin de semana, mover al siguiente día hábil (lunes)
    if (fechaEntregaMax.is().saturday()) {
        fechaEntregaMax = fechaEntregaMax.addDays(2); // Mover al lunes
    } else if (fechaEntregaMax.is().sunday()) {
        fechaEntregaMax = fechaEntregaMax.addDays(1); // Mover al lunes
    }
    
    // Verificar si el período incluye fin de semana
    let diasRealesEntrega = diasTotales;
    let diasRealesEntregaMax = Math.round((fechaEntregaMax - fechaActual) / (24 * 60 * 60 * 1000));
    
    // Determinar el formato de visualización
    // Para entregas rápidas (1-3 días), mostrar en horas cuando no hay fin de semana entre hoy y la entrega
    if (diasDeEntrega <= 3 && diasRealesEntrega <= 3) {
        if (diasDeEntrega == 1 && !hayFinDeSemanaEntre(fechaActual, fechaEntrega)) {
            document.getElementById('toDate2').innerHTML = "24 a";
            document.getElementById('fromDate2').innerHTML = "48 horas";
        } else if (diasDeEntrega == 2 && !hayFinDeSemanaEntre(fechaActual, fechaEntregaMax)) {
            document.getElementById('toDate2').innerHTML = "48 a ";
            document.getElementById('fromDate2').innerHTML = "72 horas";
        } else if (diasDeEntrega == 3 && !hayFinDeSemanaEntre(fechaActual, fechaEntregaMax)) {
            document.getElementById('toDate2').innerHTML = "3 a ";
            document.getElementById('fromDate2').innerHTML = "4 días hábiles";
        } else {
            // Si hay fin de semana en el medio, mostrar días hábiles
            document.getElementById('toDate2').innerHTML = diasDeEntrega + " a ";
            document.getElementById('fromDate2').innerHTML = (diasDeEntrega + 1) + " días hábiles";
        }
    } 
    // Para el resto de los casos, mostrar días hábiles
    else {
        document.getElementById('toDate2').innerHTML = diasDeEntrega + " a ";
        document.getElementById('fromDate2').innerHTML = (diasDeEntrega + 1) + " días hábiles";
    }
    
    console.log('toDate2:', document.getElementById('toDate2').innerHTML);
    console.log('fromDate2:', document.getElementById('fromDate2').innerHTML);
}

// Función para verificar si hay fin de semana entre dos fechas
function hayFinDeSemanaEntre(fechaInicio, fechaFin) {
    let fechaTemp = fechaInicio.clone();
    while (fechaTemp <= fechaFin) {
        if (fechaTemp.is().saturday() || fechaTemp.is().sunday()) {
            return true;
        }
        fechaTemp = fechaTemp.addDays(1);
    }
    return false;
}